import React, { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { toBlob } from "html-to-image";
import { useSelector } from "react-redux";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
function RectangleClassifieds({ preview }) {
  const componentId = useSelector((state) => state.Head.component_id);
  const [styleObject, setStyleObject] = useState({background: 'linear-gradient(135deg, #F9F2E8, #FCCFBA, #F9F2E8)' })
  const handleDownloadPreview = () => {
    const previewElement = document.querySelector(".download-preview");
    toBlob(previewElement).then(function (blob) {
      saveAs(blob, `${preview.name}.png`);
    });
  };
useEffect(()=>{
  if(preview.background !== '0' || preview.gallery?.background !== '0'){
    switch (preview.background || preview.gallery?.background) {
      case '1':
        setStyleObject({background: 'linear-gradient(135deg, #F9F2E8, #FCCFBA, #F9F2E8)'})
        break;
      case '2':
        setStyleObject({background: 'linear-gradient(135deg, #F9E6E2, #BAFAC6), #CACAFD'})
        break;
      case '3':
        setStyleObject({background:'linear-gradient(135deg, #E0F9F6, #FFF4A4, #FEDAC4)'})
        break;
      default:
        setStyleObject({background: 'linear-gradient(135deg, #F9F2E8, #FCCFBA, #F9F2E8)'})
        break;
    }
  }
},[preview.background , preview.gallery?.background])
  return (
    <>
      <div className="flex mb-5">
        {componentId === 6 ? (
          <div className="justify-end">
            <sl-icon-button
              library="lucide"
              name="download"
              onClick={handleDownloadPreview}
            ></sl-icon-button>
          </div>
        ) : null}
      </div>
      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />
        <div className="preview-inner">
          <div className="h-full grid grid-rows-5 gap-2 p-2">
            <div className="grid-rows-1 bg-green-200 rounded-md p-1" style={styleObject}>
              <div className="flex flex-col justify-between">
              <div className="flex justify-start gap-2  pt-1 items-start">
                {preview.img_urls ? <img src={preview.img_urls} className="w-[60px] h-[45px] object-cover rounded-lg"  alt="titleimage" />: null}
                <div>
                  <h3 className="!text-[16px] font-bold">{preview.headline || preview.head_line}</h3>
                </div>
              </div>
                  <p className="text-[12px] mb-0 font-semibold overflow-hidden leading-[16px]">{preview.description}</p>
               
              {preview.button_enabled ? <button style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr }} className="px-2 py-1 bg-green-500 rounded-md text-xs max-w-fit ml-auto mt-[-12px]"><span className="flex gap-1 items-center">{(preview.btn_type === '0' || preview.gallery?.btn_type === '0') ? '': <SlIcon  name={(preview.btn_type === '1' || preview.gallery?.btn_type === '1')? 'telephone' : 'whatsapp'}></SlIcon>}{preview.button_text}</span></button> : null}
              </div> 
            </div>
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="grid-rows-1 bg-slate-100 rounded-md"></div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default RectangleClassifieds;
